import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { ParamsClean } from '@/common/decorators/params-clean'
export interface MessageQueryParams {
  page: number
  limit: number
  // eslint-disable-next-line no-magic-numbers
  status: 0 | 1 | 2 // 0-进行中,1-完成,2-失败
  start_time: number | string
  end_time: number | string
  task_type: number
  device_id: string
}

export interface Message {
  task_id: string
  sender: string
  task_type: string|number
  detail: string
  create_time: number
  success_count: number
  failed_count: number
  unexecuted_count: number
}

export interface TaskItem {
  task_type: number // 任务类型
  name: string // 类型名
}

@Injectable()
export class MessagePushService {
  constructor (private http: Http) {
  }

  @ParamsClean()

  getMessageList (params: Partial<MessageQueryParams>, isTerminalInfo: boolean) {
    const url = isTerminalInfo ? '/terminal-order/command-stat-deviceid' : '/terminal-order/command-stat'
    return this.http.post<{
      total: number
      list: Message[]
    }>(url, params)
  }
  download (type: 0|1, options: Partial<MessageQueryParams>, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/terminal-order/command-stat/export', params, moduleName)
  }

  getTaskType () {
    return this.http.post<{
      list: TaskItem[]
    }>('/terminal-order/task-type/get', {})
  }

  cancel (params: Partial<{
    task_id: string
  }>) {
    return this.http.post('/terminal-order/task/cancel', params)
  }
}
